import { Link } from "react-router-dom";

const entries = [
  {
    to: "/plot",
    icon: "ri-book-open-line",
    tag: "深度解析",
    title: "电影剧情介绍",
    desc: "从科考档案到绿色迷宫，完整梳理《激情丛林》的故事脉络与角色命运。",
  },
  {
    to: "/reviews",
    icon: "ri-chat-quote-line",
    tag: "口碑声音",
    title: "影评推荐",
    desc: "专业影评人视角与普通观众声音并存，从空间叙事聊到表演细节。",
  },
  {
    to: "/news",
    icon: "ri-newspaper-line",
    tag: "持续更新",
    title: "最新资讯",
    desc: "幕后花絮、活动报道与官方公告，实时跟进影片相关的一切动态。",
  },
];

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {entries.map((e) => (
          <Link
            key={e.to}
            to={e.to}
            className="panel group relative overflow-hidden rounded-lg p-6 transition-colors duration-300 hover:border-primary-500"
          >
            <div className="flex items-center justify-between">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-900 text-accent-400 transition-colors group-hover:bg-primary-600 group-hover:text-background-50">
                <i className={`${e.icon} text-2xl`}></i>
              </span>
              <span className="font-label text-[11px] uppercase tracking-[0.2em] text-secondary-400">
                {e.tag}
              </span>
            </div>
            <h3 className="mt-5 font-heading text-lg font-bold text-foreground-50">{e.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-400">{e.desc}</p>
            <span className="mt-5 inline-flex items-center gap-1.5 font-label text-sm text-accent-500">
              进入栏目
              <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}